import { Component, Shark, Utils } from "shark-mvc";
import moment from "moment";

import templateContent from "./export-CSV.html";

class ExportCSVComponent extends Component {
	constructor () {
		super("exportCSVComponent");
		this.addTemplate("", templateContent);
	}

	beforeRender () {
		this.set({
			__showExportCSVButton: true
		});
	}

	//"address" = "";
	//"agentAssignmentDate" = "0000-00-00 00:00:00";
	//"association" = "";
	//"city" = "";
	//"code" = "";
	//"contactPerson" = "";
	//"contactSource" = "";
	//"country" = "";
	//"createdAt" = "0000-00-00 00:00:00";
	//"createdByGuid" = "";
	//"email" = "";
	//"enabled" = false;
	//"guid" = "";
	//"latestFollowUp" = "";
	//"name" = "";
	//"notes" = "";
	//"phone" = "";
	//"pictureURL" = "";
	//"preferences" = {};
	//"profession" = "";
	//"province" = "";
	//"referenceAgentsGuids" = [];
	//"region" = "";
	//"sector" = "";
	//"starred" = false;
	//"status" = 1;
	//"updatedAt" = "0000-00-00 00:00:00";
	//"updatedByGuid" = "";

	//"__agentAssignmentDateLabel" = "";
	//"__agentAssignmentStatus" = "";
	//"__displayIndex" = 0;
	//"__followUpList" = [];
	//"__formattedNotes" = "";
	//"__index" = 0;
	//"__prospectAssignedAgentGuid" = "";
	//"__hasAppointment" = false;
	//"__nextAppointment" = {};

	init () {
		this.set({
			activeMap: "Default",
			activeMapIndex: 0,
			listIsShippingList: true,
			listToExport: null,
			savedFileBaseName: "Lista",
		});
		// this.set("exportMaps", [
		// 	//Dave.ToDo: Trasformiamo queste mappe in coppie così da non dover impazzire tra i due array
		// 	// {
		// 	// 	name: "Prospect",
		// 	// 	id: "defaultProspectFieldMap",
		// 	// 	fields: ["__displayIndex", "code", "name", "email", "phone", "address", "city", "province", "region", "contactSource", "contactPerson", "association", "country", "createdAt", "latestFollowUp", "notes", "profession", "sector", "status", "updatedAt", "__agentAssignmentDateLabel", "__prospectAssignedAgentName", "__agentAssignmentStatus", "__followUpList"],
		// 	// 	titles: ["#", "codice", "nome", "email", "telefono", "indirizzo", "città", "provincia", "regione", "origine contatto", "persona di riferimento", "association", "nazione", "creato il", "ultimo follow up", "note", "profession", "settore merceologico", "status", "ultima modifica", "assegnato il", "assegnato a", "__agentAssignmentStatus", "__followUpList"]
		// 	// },
		// 	// {
		// 	// 	name: "Visit",
		// 	// 	id: "visitFieldMap",
		// 	// 	fields: [
		// 	// 		"__referenceDateLabel", "prospectName", "prospectSector", "address", "city", "province", "email", "phone", "notes", "contactName", "clientName", "buyers", "constructionCompanies", "designers", "notInterestedReason", "offerStatus", "outcomeNote", "reason", "region", "role", "__contactSourceLabel", "__outcomeLabel", "__futureContactDateLabel"],
		// 	// 	titles: [
		// 	// 		"Date visita", "nome azienda", "settore", "indirizzo", "città", "provincia", "email", "telefono", "note", "nome contatto", "clientName", "buyers", "constructionCompanies", "designers", "notInterestedReason", "offerStatus", "outcomeNote", "reason", "region", "role", "origine contatto", "esito visita", "ricontattare in data"]
		// 	// },
		// 	{
		// 		name: "Visit",
		// 		id: "visitFieldMap",
		// 		fields: {
		// 			__referenceDateLabel: "Date visita",
		// 			prospectName: "nome azienda",
		// 			prospectSector: "settore",
		// 			address: "indirizzo",
		// 			city: "città",
		// 			province: "provincia",
		// 			email: "email",
		// 			phone: "telefono",
		// 			notes: "note",
		// 			contactName: "nome contatto",
		// 			clientName: "clientName",
		// 			buyers: "buyers",
		// 			constructionCompanies: "constructionCompanies",
		// 			designers: "designers",
		// 			notInterestedReason: "notInterestedReason",
		// 			offerStatus: "offerStatus",
		// 			outcomeNote: "outcomeNote",
		// 			reason: "reason",
		// 			region: "region",
		// 			role: "role",
		// 			__contactSourceLabel: "origine contatto",
		// 			__outcomeLabel: "esito visita",
		// 			__futureContactDateLabel: "ricontattare in data"
		// 		}
		// 	// },
		// 	// {
		// 	// 	name: "Prospect2",
		// 	// 	id: "defaultProspectFieldMap2",
		// 	// 	fields: [{__displayIndex: "#"}, {code: "codice"}, {name: "nome"}, {email: "email"}, {phone: "telefono"}, {address: "indirizzo"}, {city: "città"}, {province: "provincia"}, {region: "regione"}, {country: "nazione"}, {__contactSourceLabel: "origine contatto"}, {contactPerson: "persona di riferimento"}, {association: "associazione"}, {createdAt: "creato il"}, {latestFollowUp: "ultimo follow up"}, {notes: "note"}, {profession: "profession"}, {sector: "settore merceologico"}, {status: "status"}, {updatedAt: "ultima modifica"}, {__agentAssignmentDateLabel: "assegnato il"}, {__prospectAssignedAgentName: "assegnato a"}, {__agentAssignmentStatus: "__agentAssignmentStatus"}, {__followUpList: "__followUpList"}]
		// 	}
		// ]);
	}

	generateCSV (extractTitleRow = true) {
		const activeMapIndex = this.get("activeMapIndex");
		const shippingList = this.get("listToExport");
		const maps = this.get("exportMaps");
		let currMapTitles = [];
		let currMapFields = [];
		const currMap = this.get("exportMap") || maps[activeMapIndex];
		for (let currField in currMap.fields) {
			currMapFields.push(currField);
			currMapTitles.push(currMap.fields[currField]);
		}

		// console.log({currMapFields, currMapTitles});

		let csvData = "";

		if (shippingList.length > 0) {
			if (extractTitleRow) {
				csvData = "\"" + currMapTitles.join("\";\"") + "\"\r\n";
			}

			csvData += shippingList.map(function (shipping) {
				return "\"" + currMapFields.map(function (field) {
					var value = Utils.getDeepProperty(shipping, field);
					return value ? value.toString().replace(/"/g, "'") : "";
				}).join("\";\"") + "\"";
			}).join("\r\n");
		}

		return csvData;
	}

	saveCSVFileToUser (csvContent) {
		const savedFileBaseName = this.get("savedFileBaseName");

		var link = document.createElement("a");
		var csvDataBlob = new Blob([csvContent], {encoding: "UTF-8", type: "text/csv;charset=UTF-8"}); 
		var csvUrl = URL.createObjectURL(csvDataBlob);

		link.setAttribute("href", csvUrl);
		link.setAttribute("style", "display: none;");
		link.setAttribute("download", moment().format("YYYY.MM.DD") + " - " + savedFileBaseName + ".csv");
		// link.innerHTML= "Click Here to download";
		// document.body.appendChild(link);

		link.click();
		link.remove();
	}
	
	exportCSVBtn_clickHandler () {
		const csvData = this.generateCSV();
		
		if (csvData !== "") {
			this.saveCSVFileToUser(csvData);
		}
		else {
			alert("Nessuna riga da esportare!");
		}
	}

	setActiveMap (mapName) {
		this.set({
			activeMap: mapName,
			activeMapIndex: Utils.safp(this.get("exportMaps"), "name", mapName, "index")
		});
	}
}

const exportCSVComponent = new ExportCSVComponent();

Shark.registerComponent(exportCSVComponent);

export default exportCSVComponent;
